import type { ReactNode } from 'react';
import { Icon } from './Icon';
import s from './States.module.css';

export function Alert({ tone = 'warn', icon, title, children, action }: { tone?: 'warn' | 'danger' | 'info'; icon?: string; title: ReactNode; children?: ReactNode; action?: ReactNode }) {
  return (
    <div className={[s.alert, s[tone]].join(' ')}>
      <Icon name={icon || (tone === 'info' ? 'info' : 'alert')} />
      <div className={s.main}>
        <strong>{title}</strong>
        {children && <p>{children}</p>}
      </div>
      {action && <div className={s.act}>{action}</div>}
    </div>
  );
}

/** 空态：说明要给出下一步，不能只写「暂无数据」（文档 18 §7.6） */
export function Empty({ icon = 'inbox', title, children, action }: { icon?: string; title: ReactNode; children?: ReactNode; action?: ReactNode }) {
  return (
    <div className={s.empty}>
      <div className={s.ico}><Icon name={icon} size={24} /></div>
      <h4>{title}</h4>
      {children && <p>{children}</p>}
      {action}
    </div>
  );
}

/** 加载失败：独立错误页，写清失败的是什么、下一步做什么 */
export function WifiOffMark({ className }: { className?: string } = {}) {
  return <div className={[s.ico, s.bad, className].filter(Boolean).join(' ')}><svg width="24" height="24" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M2 6.2a8.6 8.6 0 013-1.8M8.6 3.9A8.6 8.6 0 0114 6.2M4.2 8.6a5.4 5.4 0 012.3-1.2M11.8 8.6a5.4 5.4 0 00-1.2-.8M6.4 11a2.3 2.3 0 013.2 0"/><path d="M2.4 2.4l11.2 11.2"/></svg></div>;
}

export function ErrorState({ title = '加载失败', message, onRetry, detail }: { title?: string; message: string; onRetry?: () => void; detail?: string }) {
  return (
    <div className={s.empty}>
      <WifiOffMark />
      <h4>{title}</h4>
      <p>{message}</p>
      {detail && <code className={s.code}>{detail}</code>}
      {onRetry && (
        <button type="button" className={s.retry} onClick={onRetry}>重试</button>
      )}
    </div>
  );
}

export function Skeleton({ lines = 4 }: { lines?: number }) {
  const widths = ['46%', '34%', '100%', '62%', '80%', '55%'];
  return (
    <div className={s.skel}>
      {Array.from({ length: lines }, (_, i) => (
        <i key={i} style={{ width: widths[i % widths.length], height: i === 2 ? 40 : undefined }} />
      ))}
    </div>
  );
}
